// vue cli uses define plugin which dumps a big import.meta.env object here so to shorten produced js file we use it
// only once
import packageJson from '@root/package.json'

const envVars = import.meta.env

const isProd = envVars.PROD && envVars.VITE_APP_HEROKU_ENV === 'production'

export const { version } = packageJson
export const GATEWAY_DOMAIN = envVars.PROD
  ? envVars.VITE_APP_GATEWAY_DOMAIN
  : envVars.VITE_APP_GATEWAY_TESTING_DOMAIN
export const PUBLIC_SITE_DOMAIN = envVars.VITE_APP_PUBLIC_SITE_DOMAIN
export const SEARCH_ADS_INSIGHTS_DOMAIN = envVars.VITE_APP_SEARCH_ADS_INSIGHTS_DOMAIN
export const STRIPE_PUBLISHABLE_KEY = envVars.VITE_APP_STRIPE_PUBLISHABLE_KEY
export const DEBUG_SESSION_EXPIRED = `${envVars.VITE_APP_DEBUG_SESSION_EXPIRED}`.toLowerCase() === 'true'
export const DEBUG_MISSING_KEYWORDS = `${envVars.VITE_APP_DEBUG_MISSING_KEYWORDS}`.toLowerCase() === 'true'
export const SA_INTEG_CALLBACK_URL = envVars.VITE_APP_SA_INTEG_CALLBACK_URL
export const GOOGLE_RECAPTCHA_SITE_KEY = envVars.VITE_APP_GOOGLE_RECAPTCHA_KEY
export const AD_INTEL_DOMAIN = envVars.VITE_APP_AD_INTEL_DOMAIN
export const production = envVars.PROD
export const MIX_PANEL_TOKEN = envVars.VITE_APP_MIX_PANEL_TOKEN
export const SEGMENT_WRITE_KEY = isProd ? envVars.VITE_APP_SEGMENT_WRITE_KEY_PROD : envVars.VITE_APP_SEGMENT_WRITE_KEY_DEV

// initialize to true on dev but main/startUp will set to proper value
export const isMa = envVars.DEV

export default {
  version,
  isMa,
  production,
  GATEWAY_DOMAIN,
  PUBLIC_SITE_DOMAIN,
  SEARCH_ADS_INSIGHTS_DOMAIN,
  STRIPE_PUBLISHABLE_KEY,
  DEBUG_SESSION_EXPIRED,
  DEBUG_MISSING_KEYWORDS,
  GOOGLE_RECAPTCHA_SITE_KEY,
  AD_INTEL_DOMAIN,
  SA_INTEG_CALLBACK_URL,
  MIX_PANEL_TOKEN,
  SEGMENT_WRITE_KEY,
}
